<main class="self-service-page">
  <!-- <nav class="screen-orbit-nav" [class.is-open]="navigationOpen" [class.is-dragging]="launcherDragging"
    [style.left.px]="launcherPosition?.x" [style.top.px]="launcherPosition?.y"
    [style.right]="launcherPosition ? 'auto' : null" [style.bottom]="launcherPosition ? 'auto' : null"
    (pointerdown)="startLauncherDrag($event)" aria-label="Builder screens">
        <div id="builder-screen-menu" class="orbit-screen-items">
          <button
            type="button"
            class="orbit-screen-button"
            *ngFor="let item of availableNavigationItems; let i = index"
            [style.--orbit-index]="i"
            (click)="navigateFromLauncher(item.mode)"
            [attr.aria-label]="'Open ' + item.label"
            [attr.tabindex]="navigationOpen ? 0 : -1"
          >
            <mat-icon>{{ item.icon }}</mat-icon>
            <span>{{ item.label }}</span>
          </button>
        </div>

        <button
          type="button"
          class="orbit-center-button"
          (click)="toggleScreenNavigation()"
          [class.is-open]="navigationOpen"
          [attr.aria-expanded]="navigationOpen"
          aria-controls="builder-screen-menu"
          [matTooltip]="navigationOpen ? 'Close navigation' : currentNavigationItem.label"
        >
          <mat-icon>{{ navigationOpen ? 'close' : currentNavigationItem.icon }}</mat-icon>
          <span class="orbit-current-indicator"></span>
        </button>
  </nav> -->

  <!-- ████████████████████████ DATA BUILDER (extracted) ████████████████████████ -->
  <app-data-builder
    class="self-service-stage self-service-stage-data"
    [hidden]="viewMode !== 'data'"
    (viewModeChange)="setViewMode($event)"
    (openChat)="openSelfServiceChat()"
    (startNewChartRequest)="startNewChart()"
    (dashboardNeedsRefresh)="onChartBuilderDashboardRefresh()"
  ></app-data-builder>

  <!-- ████████████████████████ CHART BUILDER (extracted) ████████████████████████ -->
  <app-chart-builder
    class="self-service-stage self-service-stage-charts"
    [hidden]="viewMode !== 'charts'"
    [chartToEdit]="pendingEditChart"
    (addToDashboard)="onChartBuilderAddToDashboard($event)"
    (viewModeChange)="setViewMode($event)"
    (dashboardNeedsRefresh)="onChartBuilderDashboardRefresh()"
  ></app-chart-builder>


  <!-- ████████████████████████ DASHBOARD BUILDER (extracted) ████████████████████████ -->
  <app-dashboard-builder
    class="self-service-stage self-service-stage-dashboards"
    [hidden]="viewMode !== 'dashboards'"
    (viewModeChange)="setViewMode($event)"
    (editChart)="onDashboardEditChart($event)"
    (startNewChartRequest)="startNewChartFromDashboard()"
  ></app-dashboard-builder>

  <!-- ████████████████████████ DVM LAYOUT BUILDER ████████████████████████ -->
  <section class="self-service-stage self-service-stage-layout" [hidden]="viewMode !== 'layout'">
    <app-dvm-layout-builder></app-dvm-layout-builder>
  </section>

  <section class="self-service-stage self-service-stage-rules workspace stepper-workspace rule-builder-workspace" [hidden]="viewMode !== 'rules'">
    <div class="builder-panel rule-builder-panel">
      <app-rule-builder (viewModeChange)="setViewMode($event)"></app-rule-builder>
    </div>
  </section>

  <div class="glass-overlay" *ngIf="isEntityPreviewOpen" (click)="closeEntityPreview()">
    <div class="glass-popup entity-preview-popup" (click)="$event.stopPropagation()">
      <div class="entity-preview-popup-header">
        <div>
          <p class="eyebrow">Entity Preview</p>
          <h3>{{ selectedEntity }}</h3>
          <small>{{ entityTableRows.length }} rows · {{ entityTableColumns.length }} visible columns</small>
        </div>
        <button type="button" class="close-popup-button" (click)="closeEntityPreview()" matTooltip="Close preview">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <div class="entity-preview-popup-body">
        <div class="table-wrap">
          <table>
            <thead>
              <tr><th *ngFor="let column of entityTableColumns">{{ column }}</th></tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of entityTableRows">
                <td *ngFor="let column of entityTableColumns">{{ row[column] }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>

  <!-- Chat dialog template — rendered at body level via MatDialog to avoid position:fixed issues inside sidenav transforms -->
  <ng-template #chatDialogTemplate>
    <app-self-service-chat
      [selectedEntity]="selectedEntity"
      [availableColumns]="selfServiceChatColumns"
      [dashboardName]="dashboardName"
      (closed)="closeSelfServiceChat()"
      (missingFieldSelectionsChange)="onSelfServiceChatSelectionsChange($event)"
    ></app-self-service-chat>
  </ng-template>

  <!-- What's New dialog template — same body-level MatDialog pattern as the chat dialog -->
  <ng-template #whatsNewDialogTemplate>
    <app-whats-new (closed)="closeWhatsNew()" (openGuide)="openHelp($event)"></app-whats-new>
  </ng-template>
</main>





